// How long the object URL outlives the click. Revoking it in the same tick can cancel the save in
// some browsers; a few seconds is plenty for the browser to have taken the bytes.
const REVOKE_AFTER_MS = 10_000;

// Hands bytes already in memory to the browser as a download: an object URL and a programmatic
// `<a download>`. The file was fetched by the api-client with the token in the Authorization header,
// so the only URL the browser ever sees is a local `blob:` one — never the API URL, never the token.
export function saveFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, REVOKE_AFTER_MS);
  }
}
